export type TranslateLike = (key: string, ...args: any[]) => string;

export type EnumKeyMap = Record<string, string>;

export const getEnumValueLabel = (
  t: TranslateLike,
  value: string | number | null | undefined,
  keyMap: EnumKeyMap,
) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const rawValue = String(value);
  const key = keyMap[rawValue];

  if (!key) {
    return rawValue;
  }

  return t(key);
};
